// extracted by mini-css-extract-plugin
export var callCard = "_lv-0";
export var callMessageButton = "_lv-1";
export var helpIcon = "_lv-3";
export var helpIconContainer = "_lv-4";
export var verticalDivider = "_lv-2";